import ApiService from '../api.service';

const contractsService = {
    getContractDebt: async payload => {
        try {
            const response = await ApiService.post('debt/getContractDebt', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getUserObjectContractsList: async function({ contract_rid, currentItem, itemsPerPage }) {
        try {
            const response = await ApiService.get('docs/getUserObjectContractsList', { params: { icontract_rid: contract_rid, currentItem, itemsPerPage } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getUserObjectContractsDetailList: async function(obj_contract_rid) {
        try {
            const response = await ApiService.get('docs/getUserObjectContractsDetailList', { params: { obj_contract_rid } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    createPreTrialNotice: async payload => {
        try {
            const response = await ApiService.post('debt/addContractsPreTrialNotice', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getPreTrialNotices: async function(payload) {
        try {
            const response = await ApiService.post('docs/getContractsPreTrialNotice', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getPreTrialNoticePDF: async payload => {
        try {
            const response = await ApiService.post('docs/getContractsPreTrialNoticePDF', { pretrial_notices: payload }, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    sendPdfToEmail: async payload => {
        try {
            const response = await ApiService.post('docs/sendContractPreTrialNoticePDFToMail', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getPreTrialNoticeDetails: async payload => {
        try {
            const response = await ApiService.get('docs/getContractsPreTrialNoticeDetail', { params: { i_contracts_operation_action: payload } });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    editPreTrialNoticeDetails: async payload => {
        try {
            const { receiver_name, id, doc_delivery_date, comment, e_mail, contacts_receiver, job_position_type_rid, abonent_was_not } = payload;
            const payloadData = {
                contract_operation_action_rid: id,
                doc_delivery_date,
                receiver_name,
                comment,
                contacts_receiver,
                e_mail,
                job_position_type_rid,
                abonent_was_not
            };
            const response = await ApiService.post('docs/editContractsPreTrialNotice', { nvcOperationActionData: payloadData }, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getContractsPreTrialNoticeToSign: async payload => {
        try {
            const response = await ApiService.get('docs/getContractsPreTrialNoticeToSign', { params: { pretrial_notice_rid: payload } }, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    deleteContractPreTrialNotice: async payload => {
        try {
            const response = await ApiService.delete(`docs/delContractPreTrialNotice?pretrial_notice_rid=${payload}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default contractsService;
